// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"Blur_root__pB7r+","amount-sm":"Blur_amount-sm__n5P8i","amount-md":"Blur_amount-md__lEPuv","amount-lg":"Blur_amount-lg__Zosly"};